// extracted by mini-css-extract-plugin
export default {"positiveColor":"#49A078","negativeColor":"#D33F49"};